import React, { useState } from 'react';
import Proptypes from 'prop-types';

import { caracteresUnicode } from './Utilitarios';

const Tabla = ({
  columns,
  data,
  searcheable,
  pagination,
  rows,
  total,
  indice,
  processing,
  onPagination,
  onSearching,
  onChangeSearching,
  onDoubleClick,
  onSelectedRow,
  hoverSelectedRow,
  emptyRowsMessage,
  error,
  ...rest
}) => {
  const [page, setPage] = useState(1);

  const headers = () =>
    columns
      .filter((x) => x.hide === undefined || x.hide === false)
      .map((item, index) => (
        <th
          key={item.key}
          width={item.width}
          className={`${index > 1 ? 'sm-hide' : ''}`}
        >
          {item.label ? item.label : ''}
        </th>
      ));

  const cell = (obj, fila, index) => (
    <td
      key={obj.key}
      align={obj.align}
      className={`${index > 2 ? 'sm-hide' : ''}`}
      data-label={index > 1 && obj.label ? `${obj.label} : ` : ''}
    >
      {index === 0 ? (
        <>
          <label
            onClick={(e) => handleHide(e)}
            className="op-table-ocultar"
          ></label>
          {obj.content ? obj.content(fila) : fila[obj.key]}
        </>
      ) : obj.content ? (
        obj.content(fila)
      ) : (
        fila[obj.key]
      )}
    </td>
  );

  const row = (fila, key) => (
    <tr
      key={key}
      onClick={(e) => {
        handleClickRow(e);
        onSelectedRow ? onSelectedRow(fila) : {};
      }}
      onDoubleClick={() => {
        onDoubleClick ? onDoubleClick(fila) : {};
      }}
    >
      {columns
        .filter((x) => x.hide === undefined || x.hide === false)
        .map((obj, index) => cell(obj, fila, index))}
    </tr>
  );

  const elements = [];
  if (!(total && total > 0)) {
    pagination = false;
  } else {
    let totalPages = Math.trunc(total / rows);
    let currentePage = (page - 1) / rows;
    let beforePages = currentePage - 1;
    let afterPages = currentePage + 1;

    if (totalPages > 6) {
      if (currentePage > 1) {
        elements.push({
          selectable: true,
          label: '1',
          order: 0,
        });
        if (currentePage > 2) {
          elements.push({
            selectable: false,
            label: '...',
            order: -1,
          });
        }
      }

      if (currentePage === totalPages - 1) {
        beforePages = beforePages - 2;
      } else if (currentePage === totalPages - 2) {
        beforePages = beforePages - 1;
      }

      if (currentePage === 0) {
        afterPages = afterPages + 2;
      } else if (currentePage === 1) {
        afterPages = afterPages + 1;
      }

      for (
        let pageLength = beforePages;
        pageLength <= afterPages;
        pageLength++
      ) {
        if (pageLength > totalPages - 1) {
          continue;
        }
        if (pageLength === -1) {
          pageLength = pageLength + 1;
        }
        elements.push({
          selectable: true,
          label: `${pageLength + 1}`,
          order: pageLength,
        });
      }

      if (currentePage < totalPages - 2) {
        if (currentePage < totalPages - 3) {
          elements.push({
            selectable: false,
            label: '...',
            order: -2,
          });
        }
        elements.push({
          selectable: true,
          label: `${totalPages}`,
          order: totalPages - 1,
        });
      }

      if (total > totalPages * rows) {
        elements.push({
          selectable: true,
          label: `${totalPages + 1}`,
          order: totalPages,
        });
      }
    } else {
      for (let i = 0; i <= totalPages; i++) {
        elements.push({
          selectable: true,
          label: `${i + 1}`,
          order: i,
        });
      }
    }
  }

  let datos = null;
  if (processing) {
    datos = datos = (
      <tr className="op-procesando">
        <td colSpan={columns.length}>
          Procesando...
          <i className="op-loading-mini"></i>
        </td>
      </tr>
    );
  } else if (data.length === 0) {
    datos = (
      <tr className="op-vacio">
        <td colSpan={columns.length}>{emptyRowsMessage}</td>
      </tr>
    );
  } else {
    datos = data.map((i) => row(i, i[Object.keys(i)[indice]]));
  }

  function handleClickRow(e) {
    e.preventDefault();
    let fila = e.target;
    fila
      .closest('tbody')
      .querySelectorAll('tr')
      .forEach((element) => {
        element.classList.remove('op-seleccionado');
      });

    fila.parentElement.classList.add('op-seleccionado');
  }

  const handleClickPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let page = e.target;

    setPage(parseInt(page.dataset.page) + 1);
    onPagination({ page: parseInt(page.dataset.page), rows });
  };

  const handleHide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.closest('tr').classList.toggle('off');
  };

  const handlePaginado = () => {
    let p = Math.trunc(page / rows) + 1;
    return p * rows > total ? total : p * rows;
  };

  const handleMovePage = (valor) => {
    let p = Math.trunc(page / rows) + valor;
    let newPage = p * rows + 1;
    setPage(newPage);
    onPagination({ page: newPage - 1, rows });
  };

  const handlePressSearch = (e) => {
    let re = new RegExp(`[a-zA-Z0-9-\_${caracteresUnicode()}]`);
    if (e.key === 'Enter') {
      setPage(1);
      onSearching(e.target.value);
    }
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className={`op-table ${error ? ' error' : ''}`} {...rest}>
      {searcheable && (
        <div className="op-search">
          <input
            type="text"
            placeholder="Buscar..."
            data-search="texto"
            onKeyPress={(e) => handlePressSearch(e)}
            onChange={(e) => onChangeSearching(e.target.value)}
            onPaste={(e) => e.preventDefault()}
          />
          <i
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setPage(1);
              onSearching(
                e.target.closest('.op-search').querySelector('input').value,
              );
            }}
            className="op-icon-search"
          ></i>
        </div>
      )}
      <table>
        <thead>
          <tr>{headers()}</tr>
        </thead>
        <tbody className={`${hoverSelectedRow ? 'op-hover' : ''}`}>
          {datos}
        </tbody>
        {error && (
          <tfoot>
            <tr className="op-form-error">
              <td colSpan={columns.length}>{error}</td>
            </tr>
          </tfoot>
        )}
      </table>
      {pagination && (
        <div className="op-pagination">
          <span>{`Del ${page} al ${handlePaginado()} de ${total} registros`}</span>
          <ul>
            <li
              className={`op-prev${page === 1 ? ' disabled' : ''}`}
              onClick={() => handleMovePage(-1)}
            ></li>
            {elements.map((item) => (
              <li
                key={item.order}
                onClick={(e) => (item.selectable ? handleClickPage(e) : null)}
                data-page={rows * item.order}
                data-rows={rows}
                className={`op-pagina${
                  rows * item.order === page - 1 ? ' op-current' : ''
                }`}
              >
                {item.label}
              </li>
            ))}
            <li
              className={`op-next${
                Math.trunc(page / rows) + 1 >
                Math.trunc(total / rows) + (total % rows > 0 ? 0 : -1)
                  ? ' disabled'
                  : ''
              }`}
              onClick={() => handleMovePage(+1)}
            ></li>
          </ul>
        </div>
      )}
    </div>
  );
};

Tabla.propTypes = {
  columns: Proptypes.arrayOf(
    Proptypes.shape({
      key: Proptypes.string.isRequired,
      label: Proptypes.string,
      align: Proptypes.oneOf(['center', 'left', 'right']),
      width: Proptypes.string,
      hide: Proptypes.bool,
      content: Proptypes.func,
    }),
  ),
  data: Proptypes.array.isRequired,
  onPagination: Proptypes.func,
  onSearching: Proptypes.func,
  onChangeSearching: Proptypes.func,
  onDoubleClick: Proptypes.func,
  onSelectedRow: Proptypes.func,
  processing: Proptypes.bool,
  pagination: Proptypes.bool,
  searcheable: Proptypes.bool,
  hoverSelectedRow: Proptypes.bool,
  total: Proptypes.number,
  rows: Proptypes.number,
  indice: Proptypes.number,
  emptyRowsMessage: Proptypes.string,
  error: Proptypes.string,
};

Tabla.defaultProps = {
  data: [],
  searcheable: true,
  pagination: true,
  rows: 10,
  processing: false,
  indice: 0,
  hoverSelectedRow: true,
  emptyRowsMessage: 'No se encontraron registros',
};

export default Tabla;
